import apiClient from "./apiClient";
import {JobConfigsInterface, JobHistoryInterface} from "../containers/SystemBatchRun/SystemBatchRun.interface";

const fetchJobConfigsRequestAPI = async (): Promise<JobConfigsInterface[]> => {
	try {
		const response = await apiClient.get(`${process.env.REACT_APP_API_URL}/api/admin/system/batchJob/jobConfigs`);
		return response.data;
	} catch (e) {
		console.log('fetchJobConfigsRequestAPI error:');
		console.error(e);
		return [];
	}
}

const fetchJobHistoryRequestAPI = async ({page = 1, queueName, limit = 20}
                                         : {
	page: number,
	queueName: string,
	limit: number
}): Promise<JobHistoryInterface[]> => {
	try {
		const offset = (page - 1) * limit;
		const queryStr = `?offset=${offset}&limit=${limit}`;
		const response = await apiClient.get(`${process.env.REACT_APP_API_URL}/api/admin/system/batchJob/${queueName}/history${queryStr}`);
		return response.data;
	} catch (e) {
		console.log('fetchJobHistoryRequestAPI error:');
		console.error(e);
		return [];
	}
}


const runBatchJobRequestAPI = async (queueName: string): Promise<any> => {
	const response = await apiClient.get(`${process.env.REACT_APP_API_URL}/api/admin/system/batchJob/${queueName}/run`);
	return response.data;
}


const batchAPI = {
	fetchJobConfigsRequestAPI,
	fetchJobHistoryRequestAPI,
	runBatchJobRequestAPI,
};

export default batchAPI;
